import { useTranslation } from "react-i18next";
import HeaderLogo from "../../assets/header-logo";
import { getCountry } from "../../lib/middleware";

export default function Footer() {
    const { t } = useTranslation();
    const isSaudiSubdomain =
        window.location.hostname.startsWith("sa.") || false;
    // const isUaeSubdomain = window.location.hostname.startsWith("") || false;
    const isOmSubdomain = window.location.hostname.startsWith("om.") || false;
    const country = getCountry();
    const isKsa = isSaudiSubdomain || country === "ksa";

    return (
        <div>
            <div className="bg-white pb-12 pt-20">
                <div className="container flex flex-wrap justify-between gap-4">
                    <div className="flex flex-col gap-y-6">
                        <a href="/">
                            <HeaderLogo />
                        </a>
                        <div className="flex gap-x-3">
                            <a
                                href={
                                    isKsa
                                        ? "https://wa.me/message/JNHDQWLJRWYEO1"
                                        : "/"
                                }
                                target={isKsa ? "_blank" : undefined}
                                rel={isKsa ? "noopener noreferrer" : undefined}
                                className="flex size-[50px] items-center justify-center rounded-xl p-2.5 shadow-[0px_2px_5.5px_0px_rgba(0,0,0,0.02),1px_1.22px_0.97px_0px_rgba(0,0,0,0.03),0px_0px_1.83px_0px_rgba(0,0,0,0.04),0px_3px_6.8px_0px_rgba(0,0,0,0.04)] transition hover:scale-105"
                            >
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g filter="url(#filter0_i_258_210083)">
                                        <path
                                            d="M15.0829 3.25391C8.54818 3.25391 3.25 8.55208 3.25 15.0868C3.25 17.3067 3.87354 19.3763 4.93711 21.1515L3.35593 26.9197L9.24733 25.3732C10.9703 26.3528 12.9594 26.9197 15.0829 26.9197C21.6176 26.9197 26.9158 21.6215 26.9158 15.0868C26.9158 8.55208 21.6176 3.25391 15.0829 3.25391ZM11.0327 9.56709C11.225 9.56709 11.4225 9.56592 11.5931 9.5748C11.8041 9.57973 12.0338 9.59518 12.2537 10.0813C12.515 10.6592 13.084 12.1088 13.157 12.2557C13.2299 12.4026 13.2816 12.5757 13.1801 12.768C13.0834 12.9652 13.0332 13.0846 12.8912 13.2591C12.7443 13.4287 12.5833 13.6393 12.4501 13.7675C12.3032 13.9145 12.1515 14.0756 12.3211 14.3684C12.4907 14.6613 13.0797 15.6214 13.9504 16.3964C15.0696 17.3963 16.0139 17.7036 16.3078 17.8505C16.6016 17.9974 16.7718 17.9745 16.9414 17.7773C17.1159 17.585 17.6744 16.9252 17.8716 16.6314C18.0639 16.3375 18.2602 16.3884 18.5264 16.485C18.7966 16.5817 20.2375 17.2914 20.5313 17.4384C20.8252 17.5853 21.0178 17.658 21.0918 17.7773C21.1677 17.9006 21.1678 18.4873 20.9242 19.1717C20.6807 19.855 19.4846 20.5159 18.9482 20.5622C18.4069 20.6125 17.9016 20.8055 15.4296 19.8323C12.4477 18.6579 10.5671 15.6037 10.4202 15.4065C10.2733 15.2142 9.22615 13.8186 9.22615 12.3789C9.22615 10.9343 9.98356 10.2269 10.2488 9.93302C10.519 9.63917 10.8355 9.56709 11.0327 9.56709Z"
                                            fill="#0A4C26"
                                        />
                                    </g>
                                    <defs>
                                        <filter
                                            id="filter0_i_258_210083"
                                            x="0.296875"
                                            y="0.298828"
                                            width="29.582"
                                            height="30.314"
                                            filterUnits="userSpaceOnUse"
                                            colorInterpolationFilters="sRGB"
                                        >
                                            <feFlood
                                                floodOpacity="0"
                                                result="BackgroundImageFix"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                            />
                                            <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                            />
                                            <feOffset dy="0.731978" />
                                            <feGaussianBlur stdDeviation="1.37246" />
                                            <feComposite
                                                in2="hardAlpha"
                                                operator="arithmetic"
                                                k2="-1"
                                                k3="1"
                                            />
                                            <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in2="shape"
                                                result="effect1_innerShadow_258_210083"
                                            />
                                        </filter>
                                    </defs>
                                </svg>
                            </a>
                            <a
                                href={
                                    isKsa
                                        ? "https://www.facebook.com/ZabehatySaudi/"
                                        : "https://www.facebook.com/ZabehatyApp?mibextid=LQQJ4d"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex size-[50px] items-center justify-center rounded-xl p-2.5 shadow-[0px_2px_5.5px_0px_rgba(0,0,0,0.02),1px_1.22px_0.97px_0px_rgba(0,0,0,0.03),0px_0px_1.83px_0px_rgba(0,0,0,0.04),0px_3px_6.8px_0px_rgba(0,0,0,0.04)] transition hover:scale-105"
                            >
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g
                                        clipPath="url(#clip0_258_210087)"
                                        filter="url(#filter0_i_258_210087)"
                                    >
                                        <path
                                            d="M20.0519 15.7936L20.7903 10.9836H16.1747V7.86225C16.1747 6.5466 16.8193 5.26333 18.8866 5.26333H20.9847V1.16851C20.9847 1.16851 19.081 0.84375 17.2603 0.84375C13.4595 0.84375 10.9752 3.14781 10.9752 7.31822V10.9845H6.75V15.7944H10.9752V27.4227H16.1747V15.7944L20.0519 15.7936Z"
                                            fill="#0A4C26"
                                        />
                                    </g>
                                    <defs>
                                        <filter
                                            id="filter0_i_258_210087"
                                            x="0.578125"
                                            y="0.841797"
                                            width="26.5791"
                                            height="27.3101"
                                            filterUnits="userSpaceOnUse"
                                            colorInterpolationFilters="sRGB"
                                        >
                                            <feFlood
                                                floodOpacity="0"
                                                result="BackgroundImageFix"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                            />
                                            <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                            />
                                            <feOffset dy="0.731978" />
                                            <feGaussianBlur stdDeviation="1.37246" />
                                            <feComposite
                                                in2="hardAlpha"
                                                operator="arithmetic"
                                                k2="-1"
                                                k3="1"
                                            />
                                            <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in2="shape"
                                                result="effect1_innerShadow_258_210087"
                                            />
                                        </filter>
                                        <clipPath id="clip0_258_210087">
                                            <rect
                                                width="26.579"
                                                height="26.579"
                                                fill="white"
                                                transform="translate(0.578125 0.841797)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                            <a
                                href={
                                    isKsa
                                        ? "https://www.instagram.com/zabehaty_ksa/"
                                        : "https://www.instagram.com/zabehaty/profilecard/?igsh=NTFydHAzOWRkcnBp"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex size-[50px] items-center justify-center rounded-xl p-2.5 shadow-[0px_2px_5.5px_0px_rgba(0,0,0,0.02),1px_1.22px_0.97px_0px_rgba(0,0,0,0.03),0px_0px_1.83px_0px_rgba(0,0,0,0.04),0px_3px_6.8px_0px_rgba(0,0,0,0.04)] transition hover:scale-105"
                            >
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g filter="url(#filter0_i_258_210091)">
                                        <path
                                            d="M10.1299 3.53125C6.41406 3.53125 3.39062 6.55647 3.39062 10.2732V19.9022C3.39062 23.6185 6.41584 26.6424 10.1326 26.6424H19.7616C23.4779 26.6424 26.5017 23.6171 26.5017 19.9004V10.2705C26.5017 6.55468 23.4765 3.53125 19.7598 3.53125H10.1299ZM21.8795 7.22903C22.3898 7.22903 22.804 7.64318 22.804 8.15347C22.804 8.66377 22.3898 9.07792 21.8795 9.07792C21.3692 9.07792 20.9551 8.66377 20.9551 8.15347C20.9551 7.64318 21.3692 7.22903 21.8795 7.22903ZM14.9462 9.07792C18.2603 9.07792 20.9551 11.7727 20.9551 15.0868C20.9551 18.4009 18.2599 21.0957 14.9462 21.0957C11.632 21.0957 8.93729 18.4005 8.93729 15.0868C8.93729 11.7731 11.632 9.07792 14.9462 9.07792ZM14.9462 10.9268C12.6485 10.9268 10.7862 12.7891 10.7862 15.0868C10.7862 17.3845 12.6485 19.2468 14.9462 19.2468C17.2439 19.2468 19.1062 17.3845 19.1062 15.0868C19.1062 12.7891 17.2439 10.9268 14.9462 10.9268Z"
                                            fill="#0A4C26"
                                        />
                                    </g>
                                    <defs>
                                        <filter
                                            id="filter0_i_258_210091"
                                            x="0.15625"
                                            y="0.298828"
                                            width="29.582"
                                            height="30.314"
                                            filterUnits="userSpaceOnUse"
                                            colorInterpolationFilters="sRGB"
                                        >
                                            <feFlood
                                                floodOpacity="0"
                                                result="BackgroundImageFix"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                            />
                                            <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                            />
                                            <feOffset dy="0.731978" />
                                            <feGaussianBlur stdDeviation="1.37246" />
                                            <feComposite
                                                in2="hardAlpha"
                                                operator="arithmetic"
                                                k2="-1"
                                                k3="1"
                                            />
                                            <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in2="shape"
                                                result="effect1_innerShadow_258_210091"
                                            />
                                        </filter>
                                    </defs>
                                </svg>
                            </a>
                            <a
                                href={
                                    isKsa
                                        ? "https://www.snapchat.com/@zabehaty_ksa?invite_id=bOnP5oSW&share_id=MjhKdCEhToywajUTg1APBQ&sid=5f3578f48205492ca67c972e08208e23"
                                        : "/"
                                }
                                target={isKsa ? "_blank" : undefined}
                                rel={isKsa ? "noopener noreferrer" : undefined}
                                className="flex size-[50px] items-center justify-center rounded-xl p-2.5 shadow-[0px_2px_5.5px_0px_rgba(0,0,0,0.02),1px_1.22px_0.97px_0px_rgba(0,0,0,0.03),0px_0px_1.83px_0px_rgba(0,0,0,0.04),0px_3px_6.8px_0px_rgba(0,0,0,0.04)] transition hover:scale-105"
                            >
                                <svg
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g
                                        clipPath="url(#clip0_258_210095)"
                                        filter="url(#filter0_i_258_210095)"
                                    >
                                        <path
                                            d="M13.1844 1.72461C14.1772 1.72461 17.551 2.00331 19.1396 5.56167C19.6692 6.76235 19.5434 8.79462 19.4379 10.4307V10.4894C19.4259 10.6702 19.4146 10.8389 19.4063 11.0032C19.4809 11.0461 19.6104 11.0935 19.81 11.0935C20.1083 11.0777 20.4691 10.9723 20.8457 10.7915C21.0107 10.7011 21.1907 10.6853 21.3128 10.6853C21.4935 10.6853 21.6736 10.7169 21.8227 10.7757C22.2739 10.9248 22.5601 11.2585 22.5601 11.6193C22.576 12.0705 22.1677 12.463 21.3399 12.7921C21.2533 12.8192 21.132 12.8667 20.9949 12.9096C20.5437 13.0467 19.853 13.2704 19.6571 13.7254C19.5667 13.9491 19.5984 14.2512 19.7784 14.5962L19.7942 14.612C19.853 14.7491 21.3241 18.0995 24.6037 18.6411C24.8628 18.6886 25.0429 18.9115 25.0278 19.1548C25.0273 19.2319 25.0111 19.308 24.9803 19.3786C24.7408 19.951 23.7013 20.3713 21.822 20.6576C21.7632 20.748 21.7007 21.0342 21.657 21.23C21.6236 21.4168 21.5791 21.6015 21.5237 21.7829C21.4453 22.0534 21.2487 22.1912 20.9625 22.1912H20.9354C20.7983 22.1912 20.6213 22.1596 20.3938 22.1166C19.9735 22.026 19.5448 21.98 19.1148 21.9795C18.8127 21.9795 18.5144 21.9954 18.1966 22.0541C17.5962 22.1603 17.0705 22.5211 16.4663 22.9444C15.6114 23.5448 14.6344 24.2355 13.1588 24.2355C13.1001 24.2355 13.0413 24.2197 12.978 24.2197H12.8289C11.354 24.2197 10.3929 23.5448 9.53342 22.9286C8.93308 22.5045 8.42313 22.1437 7.81902 22.0383C7.51119 21.9928 7.20066 21.9679 6.88951 21.9637C6.34792 21.9637 5.92836 22.0541 5.61049 22.1166C5.4327 22.1584 5.25137 22.1834 5.0689 22.1912C4.69228 22.1912 4.54313 21.9637 4.48438 21.7671C4.42186 21.575 4.39399 21.3747 4.34729 21.1984C4.29983 21.0176 4.24108 20.7005 4.18233 20.6259C2.25626 20.4022 1.22054 19.9827 0.977244 19.3944C0.944113 19.3229 0.925427 19.2456 0.922257 19.1669C0.917451 19.0445 0.958123 18.9247 1.03643 18.8305C1.11474 18.7364 1.22514 18.6745 1.34634 18.6569C4.62223 18.1154 6.09709 14.7611 6.15585 14.6203L6.17166 14.5932C6.35244 14.2436 6.39915 13.9461 6.29294 13.7186C6.09709 13.2832 5.40636 13.0595 4.95516 12.9066C4.83569 12.8769 4.71881 12.8376 4.60565 12.7891C3.49536 12.35 3.34245 11.8551 3.40497 11.5101C3.49536 11.0273 4.07989 10.7139 4.57778 10.7139C4.72316 10.7139 4.8482 10.741 4.96194 10.7885C5.3815 10.9806 5.75436 11.0868 6.07223 11.0868C6.30348 11.0868 6.45639 11.028 6.53925 10.9851L6.4918 10.4126C6.39387 8.78031 6.26431 6.74428 6.79762 5.55564C8.34329 2.0131 11.7058 1.74193 12.6978 1.74193L13.1174 1.72612L13.1844 1.72461Z"
                                            fill="#0A4C26"
                                        />
                                    </g>
                                    <defs>
                                        <filter
                                            id="filter0_i_258_210095"
                                            x="0.929688"
                                            y="0.929688"
                                            width="24.1045"
                                            height="24.8355"
                                            filterUnits="userSpaceOnUse"
                                            colorInterpolationFilters="sRGB"
                                        >
                                            <feFlood
                                                floodOpacity="0"
                                                result="BackgroundImageFix"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                            />
                                            <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                            />
                                            <feOffset dy="0.731978" />
                                            <feGaussianBlur stdDeviation="1.37246" />
                                            <feComposite
                                                in2="hardAlpha"
                                                operator="arithmetic"
                                                k2="-1"
                                                k3="1"
                                            />
                                            <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                            />
                                            <feBlend
                                                mode="normal"
                                                in2="shape"
                                                result="effect1_innerShadow_258_210095"
                                            />
                                        </filter>
                                        <clipPath id="clip0_258_210095">
                                            <rect
                                                width="24.104"
                                                height="24.104"
                                                fill="white"
                                                transform="translate(0.929688 0.929688)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                            <a
                                href={
                                    isKsa
                                        ? "https://x.com/Zabehaty_KSA?t=eQJb54IOGrNyX9hmoPo8Eg&s=09"
                                        : "https://x.com/zabehatyapp?s=11"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex size-[50px] items-center justify-center rounded-xl p-2.5 shadow-[0px_2px_5.5px_0px_rgba(0,0,0,0.02),1px_1.22px_0.97px_0px_rgba(0,0,0,0.03),0px_0px_1.83px_0px_rgba(0,0,0,0.04),0px_3px_6.8px_0px_rgba(0,0,0,0.04)] transition hover:scale-105"
                            >
                                <svg
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M24.3352 6.4987C23.501 6.87786 22.6019 7.12703 21.6702 7.2462C22.6235 6.67203 23.3602 5.76203 23.7069 4.66786C22.8077 5.20953 21.811 5.5887 20.7602 5.80536C19.9044 4.8737 18.7019 4.33203 17.3369 4.33203C14.791 4.33203 12.711 6.41203 12.711 8.97953C12.711 9.34786 12.7544 9.70536 12.8302 10.0412C8.97354 9.8462 5.53938 7.9937 3.25354 5.18786C2.85271 5.87036 2.62521 6.67203 2.62521 7.51703C2.62521 9.1312 3.43771 10.5612 4.69438 11.3737C3.92521 11.3737 3.21021 11.157 2.58188 10.832V10.8645C2.58188 13.1179 4.18521 15.0029 6.30854 15.4254C5.62683 15.6119 4.91114 15.6379 4.21771 15.5012C4.51195 16.4247 5.08821 17.2328 5.86548 17.8119C6.64275 18.3909 7.58194 18.7119 8.55104 18.7295C6.90831 20.03 4.87204 20.733 2.77688 20.7229C2.40854 20.7229 2.04021 20.7012 1.67188 20.6579C3.73021 21.9795 6.17854 22.7487 8.80021 22.7487C17.3369 22.7487 22.0277 15.6637 22.0277 9.5212C22.0277 9.31536 22.0277 9.12036 22.0169 8.91453C22.9269 8.26453 23.7069 7.4412 24.3352 6.4987Z"
                                        fill="#0A4C26"
                                    />
                                </svg>
                            </a>
                        </div>
                        <p className="max-w-md text-[rgba(82,82,82,1)]">
                            <p>
                                <b>{t("footer.company")}</b>
                            </p>
                            {isSaudiSubdomain
                                ? t("footer.saudidesc")
                                : t("footer.desc")}
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-x-36 gap-y-6">
                        <div className="flex flex-col gap-y-3">
                            <a
                                href="/"
                                className="text-[rgba(82,82,82,1)] transition hover:text-primary"
                            >
                                {t("navlist.home")}
                            </a>
                            <a
                                href="/terms-conditions"
                                className="text-[rgba(82,82,82,1)] transition hover:text-primary"
                            >
                                {t("navlist.nav-menu.terms-and-conditions")}
                            </a>
                            <a
                                href="/offers"
                                className="text-[rgba(82,82,82,1)] transition hover:text-primary"
                            >
                                {t("navlist.nav-menu.offers")}
                            </a>
                            <a
                                href="/store"
                                className="text-[rgba(82,82,82,1)] transition hover:text-primary"
                            >
                                {/* href="/register-store" */}
                                {t("navlist.nav-menu.register-as-a-store")}
                            </a>
                            <a
                                href="/faqs"
                                className="text-[rgba(82,82,82,1)] transition hover:text-primary"
                            >
                                {/* href="/register-store" */}
                                {t("navlist.nav-menu.faqs")}
                            </a>
                            {/* <a
                                href="/"
                                className="text-[rgba(82,82,82,1)] transition hover:text-primary"
                            >
                                {t("navlist.nav-menu.technical-support")}
                            </a> */}
                        </div>
                        {/* hiding the whatsapp section */}
                        <div className="flex flex-col gap-y-3">
                            {/* {!isSaudiSubdomain && (
                                <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                    {t("whatsapp")}: 0097128004664
                                </div>
                            )} */}
                            {(isSaudiSubdomain || country === "ksa") && (
                                <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                    {t("phone")}: 8001221100
                                </div>
                            )}
                            {!isSaudiSubdomain && country === "uae" && (
                                <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                    {t("phone")}: 8004664
                                </div>
                            )}
                            {isOmSubdomain ||
                                (country === "om" && (
                                    <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                        {t("phone")}: 0096894266036
                                    </div>
                                ))}
                            {isSaudiSubdomain && (
                                <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                    zabehaty.ksa@oasislivestock.com
                                </div>
                            )}
                            <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                info@oasislivestock.com
                            </div>
                            {(isSaudiSubdomain || country === "ksa") && (
                                <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                    {t("countries.ksa")}
                                </div>
                            )}
                            {!isSaudiSubdomain &&
                                !isOmSubdomain &&
                                country === "uae" && (
                                    <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                        {t("location")}
                                    </div>
                                )}
                            {isOmSubdomain ||
                                (country === "om" && (
                                    <div className="text-[rgba(82,82,82,1)] transition hover:text-primary">
                                        {t("countries.om")}
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[rgba(229,229,229,1)]">
                <div className="container flex flex-wrap items-center justify-between gap-4 py-6 font-medium leading-none text-[rgba(17,24,39,1)]">
                    <a
                        href="/terms-conditions"
                        className="transition hover:opacity-80"
                    >
                        {" "}
                        {t("policy")}
                    </a>
                    <div>{t("copyright")}</div>
                </div>
            </div>
        </div>
    );
}
